import { render, staticRenderFns } from "./UnfollowConfirm.vue?vue&type=template&id=19a1f353&"
import script from "./UnfollowConfirm.vue?vue&type=script&lang=ts&"
export * from "./UnfollowConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports